import { render } from "./XForm.vue?vue&type=template&id=5f5e8f40"
import script from "./XForm.vue?vue&type=script&lang=js"
export * from "./XForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__